import { DialogContentText } from '@mui/material';
import { ModalTextProps } from './Modal.types';

export default function ModalText(props: ModalTextProps) {
    const { children, sx } = props;
    return <DialogContentText sx={sx}>{children}</DialogContentText>;
}
